import axiosapi from "./axiosAPI";

// Get All Regions
export const getAllRegions = async (
    setRegions,
    setFetcherror,
) => {
    
	try{
		const res =await axiosapi.get("/regions");
        setRegions(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Regions");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Regions");
		}
		
	}
	
};

// Get All Regions Per Zone
export const getZoneRegions = async (
    setRegions,
    setFetcherror,
    pkid
) => {
    
	try{
		const res =await axiosapi.get(`/zoneregions/${pkid}`);
        setRegions(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Regions");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Regions");
		}
		
	}
	
};

// Get All Regions Per Country
export const getCountryRegions = async (
    setRegions,
    setFetcherror,
    pkid
) => {
    
	try{
		const res =await axiosapi.get(`/countryregions/${pkid}`);
        setRegions(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Regions");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Regions");
		}
		
	}
	
};



// Get One Region
export const getOneRegion = async (
    pkid,
    setFetcherror,  
    setRegion
    
)=>{
	try{
		const res =await axiosapi.get(`/regions/${pkid}`);
        setRegion(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Region");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Region");
		}
		
	}
	
};


// Create New Region
export const createRegion = async (
    region,
    zone_id,
    setRegion,
    setFetcherror,
    handleAllToasts,
    setRegions

) => {


    if (!region ) {
        handleAllToasts(2, "No Region Provided"); 
            return; 
        }

    const PushItem = {
        name: region,
        zone_id: zone_id,
        country_id:1
        };

    try{
        await axiosapi.post("/regions/",PushItem );
        setRegion("");
        handleAllToasts(1, "Region Created Successfully");
        getAllRegions(setRegions,setFetcherror);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New Region");
            handleAllToasts(2, "Could Not Create New Region");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New Region");
            handleAllToasts(2, "Could Not Create New Region");
            
        }
        
    }
    
}


// Edit Existing Region

export const editRegion = async (
    regionpkid,
    editedRegion,
    setEditedRegion,
    selectedEditedZone,
    setSelectedEditedZone,
    setFetcherror,
    handleAllToasts, setRegions
              
        ) => {

            if (!editedRegion) {
                handleAllToasts(2, "No Region Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:regionpkid,
                    name: editedRegion,
                    zone_id: selectedEditedZone?.id,
                    country_id:1
                };

            try{
                await axiosapi.patch("/regions/",PushItem );
                setEditedRegion("");
                setSelectedEditedZone("");
                handleAllToasts(1, "Region Updated Successfully");
                getAllRegions(setRegions,setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update Region");
                    handleAllToasts(2, "Could Not Update Region");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update Region");
                    handleAllToasts(2, "Could Not Update Region");
                    
                }
                
            }
            
};



// Delete Existing Region.

export const deleteRegion = async (
    regionpkid,
    setcountries,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/regions/${regionpkid}`);
        let finalData = res.data.message;
        getAllRegions(setcountries, setFetcherror);
        handleAllToasts(1, "Region Deleted Successfully");
        console.log("Deleted:", finalData);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete Region");
            handleAllToasts(2,"Error: Could Not Delete Region");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete Region");
            handleAllToasts(2,"Error: Could Not Delete Region");
		}
		
	}
	
};